import { DataGrid, SelectBox } from "devextreme-react";
import { Template } from "devextreme-react";
import {
    Column,
    Export,
    Pager,
    Paging,
    SearchPanel,
    Selection,
} from "devextreme-react/data-grid";
import React, {
    useCallback,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from "react";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import { LocalStorage } from "../../helper/appsession";
import { exportDataGrid, ExportFormats } from "../../helper/export";
import {
    DateFilter,
    DefaultDateFormat,
} from "../../helper/fixcode.js";
import moment from "moment";
import { DateBox } from "devextreme-react";
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default function UserOtpComponent() {
    const [state, setState] = useState({
        isRefresh: false,
        isSubmitted: false,
        userOtpDataSource: [],
    });

    const refDataGrid = useRef(null);
    const refStartDate = useRef(null);
    const refEndDate = useRef(null);

    useLayoutEffect(() => {
        document.querySelector("#lblPageTitle").innerHTML = "Otp";
    }, []);

    const [copyStatus, setCopyStatus] = useState(false); // To indicate if the text was copied

    let isUseEffectRendered = false;
    useEffect(() => {
        const controller = new AbortController();
        try {
            if (isUseEffectRendered) {
                return;
            }
            fetchApiOnLoad();
            return () => {
                controller.abort();
                isUseEffectRendered = true;
            };
        } catch (error) {
            console.log(error);
        }
    }, []);
    const fetchApiOnLoad = async () => {
        try {
            setTimeout(async () => {
                await getUserOtp();
            }, 0);
        } catch (error) {
            console.log(error);
        }
    };
    const setToday = (e) => {
        e.preventDefault();
        try {
            refStartDate.current.instance.option("value", moment().startOf("day"));
            refEndDate.current.instance.option("value", moment().endOf("day"));
        } catch (error) {
            console.log(error);
        }
    };
    const setYesterday = (e) => {
        e.preventDefault();
        try {
            refStartDate.current.instance.option(
                "value",
                moment().add(-1, "day").startOf("day")
            );
            refEndDate.current.instance.option(
                "value",
                moment().add(-1, "day").endOf("day")
            );
        } catch (error) {
            console.log(error);
        }
    };
    const setLastSevenDays = (e) => {
        e.preventDefault();
        try {
            refStartDate.current.instance.option(
                "value",
                moment().add(-6, "day").startOf("day")
            );
            refEndDate.current.instance.option("value", DateFilter.EndDateTime);
        } catch (error) {
            console.log(error);
        }
    };
    const getUserOtp = async () => {
        try {
            const startDate = moment(
                refStartDate.current.instance.option("value")
            ).format(`${DefaultDateFormat.SqlStartDateFormat}`);
            const endDate = moment(
                refEndDate.current.instance.option("value")
            ).format(DefaultDateFormat.SqlEndDateFormat);

            const res = await axiosPost(`/masters/user-otp`, {
                CustomerId: LocalStorage.CustomerId,
                StartDate: startDate,
                Enddate: endDate,
            });

            //console.log(res);
            setState((prev) => ({
                ...prev,
                userOtpDataSource: res.payload ?? [],
            }));
        } catch (error) {
            console.log(error);
        }
    };
    const renderGridCell = (data) => {
        return (
            <div style={{ textAlign: "left" }}>
                <CopyToClipboard text={data.data?.otp} onCopy={onCopyText}>
                    {/* <button className="btn btn-success btn-sm" onclick={(e) => handleCopyClick()}><i className="far fa-copy"></i>&nbsp;</button> */}
                    <a title="Copy to clipboard" onClick={(e) => handleCopyClick(e)}><i className="far fa-copy"></i>&nbsp;</a>
                </CopyToClipboard>
            </div>
        );
    };
    const onCopyText = () => {
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 2000); // Reset status after 2 seconds
    };

    const handleCopyClick = (e) => {
        e.preventDefault();
        // This function will be called when the user clicks thebutton
        onCopyText(); // Call the copy function
        // Additional logic for user feedback can be added here
    };

    const handleOtpSearch = async (e) => {
        e.preventDefault();
        try {
            getUserOtp();
        } catch (error) {
            console.log(error);
            setState((prev) => ({
                ...prev,
                isSubmitted: false,
            }));
        }
    };
    return (
        <>



            <div className="content">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <label>
                                            From & To Date<span className="text-danger">*</span>
                                            &nbsp;&nbsp;
                                            <a
                                                href="#"
                                                className={`btn btn-link p-0 btn-sm ${state.statusId === -1 ? "disabled" : ""
                                                    }`}
                                                onClick={setToday}
                                            >
                                                Today
                                            </a>
                                            /
                                            <a
                                                href="#"
                                                className={`btn btn-link p-0 btn-sm ${state.statusId === -1 ? "disabled" : ""
                                                    }`}
                                                onClick={setYesterday}
                                            >
                                                Yesterday
                                            </a>
                                            /
                                            <a
                                                href="#"
                                                className={`btn btn-link p-0 btn-sm ${state.statusId === -1 ? "disabled" : ""
                                                    }`}
                                                onClick={setLastSevenDays}
                                            >
                                                Last 7 Days
                                            </a>
                                        </label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <DateBox
                                            type="date"
                                            className="replay-date-time"
                                            name="startDate"
                                            placeholder={DefaultDateFormat.DateFormat}
                                            displayFormat={DefaultDateFormat.DateFormat}
                                            showAnalogClock={true}
                                            useMaskBehavior={true}
                                            defaultValue={DateFilter.StartDateTime}
                                            acceptCustomValue={false}
                                            disabled={state.statusId === -1}
                                            ref={refStartDate}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <DateBox
                                            type="date"
                                            className="replay-date-time"
                                            name="endDate"
                                            placeholder={DefaultDateFormat.DateFormat}
                                            displayFormat={DefaultDateFormat.DateFormat}
                                            showAnalogClock={true}
                                            useMaskBehavior={true}
                                            defaultValue={DateFilter.EndDateTime}
                                            acceptCustomValue={false}
                                            disabled={state.statusId === -1}
                                            ref={refEndDate}
                                        />
                                    </div>
                                    <div className="col-lg-1 col-md-1 col-sm-1">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            disabled={state.statusId === -1}
                                            onClick={(e) => handleOtpSearch(e)}
                                        >
                                            <span title="Search">
                                                <i
                                                    className={`fas fa-${state.isSubmitted ? "spinner fa-spin" : "search"
                                                        }`}
                                                ></i>
                                            </span>
                                        </button>{" "}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div>
                            <DataGrid
                                ref={refDataGrid}
                                dataSource={state.userOtpDataSource}
                                showBorders={true}
                                columnAutoWidth={true}
                                allowColumnResizing={true}
                                showRowLines={true}
                                showColumnLines={true}
                                // height={500}                            
                                onToolbarPreparing={(e) => {
                                    e.toolbarOptions.items.unshift({
                                        location: "after",
                                        widget: "dxButton",
                                        options: {
                                            icon: "refresh",
                                            hint: "Refresh",
                                            onClick: async (e) => {
                                                e.component.option("icon", "fas fa-spinner fa-spin");
                                                await getUserOtp();
                                                e.component.option("icon", "refresh");
                                            },
                                        },
                                    });
                                }}
                                onExporting={(e) => {
                                    exportDataGrid(e, "Otp");
                                }}
                            >
                                <Column
                                    dataField="id"
                                    caption=""
                                    allowSorting={false}
                                    allowSearch={false}
                                    allowExporting={false}
                                    allowFiltering={false}
                                    width={"auto"}
                                    cellRender={renderGridCell}
                                    fixed={true}
                                />
                                <Column
                                    dataField="username"
                                    caption="Mobile"
                                    allowFiltering={false}
                                    allowSearch={true}
                                />
                                <Column
                                    dataField="otp"
                                    caption="Otp"
                                    allowFiltering={false}
                                    allowSearch={true}
                                />
                                <Column
                                    dataField="createdDate"
                                    caption="Create Date"
                                    allowFiltering={false}
                                    allowSearch={true}
                                    format={DefaultDateFormat.GridDateTimeHHmmssFormat}
                                    dataType="datetime"
                                />
                                <Column
                                    dataField="expiryDate"
                                    caption="Expiry Date"
                                    allowFiltering={false}
                                    allowSearch={true}
                                    format={DefaultDateFormat.GridDateTimeHHmmssFormat}
                                    dataType="datetime"
                                />
                                <Paging defaultPageSize={15} />
                                <Pager
                                    displayMode="compact"
                                    showNavigationButtons={true}
                                    showInfo={true}
                                    visible={true}
                                />
                                <SearchPanel
                                    visible={true}
                                    highlightCaseSensitive={true}
                                    width={240}
                                    placeholder="Search..."
                                />
                                <Export
                                    enabled={true}
                                    formats={ExportFormats.xlsx}
                                    fileName="Category"
                                    allowExportSelectedData={false}
                                />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
